import Simplemodal from "../../plugins/simplemodal.js";
// import swiper from "swiper";

const resourcemodal = new Simplemodal({
  trigger: "data-resource-trigger",
  clickOutSideClose: true,
  onOpen: openAction,
  onClose: closeAction
});

function openAction() {
  document.querySelector("body").classList.add("resource-modal-open");
}
function closeAction() {
  document.querySelector("body").classList.remove("resource-modal-open");
}

document.addEventListener("click", e => {
  if (e.target.closest(".js-close-modal")) {
    resourcemodal.closeAllModal();
  }
});
